import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/subscription?${p}`);
  },
  create(data) {
    return api.post(`/api/v1/subscription`, data);
  },
  update(data) {
    return api.put(`/api/v1/subscription/${data.id}`, data);
  },
  confirm(id) {
    return api.put(`/api/v1/subscription/confirmed/${id}`);
  },
  deleteSubscription(id) {
    return api.delete(`/api/v1/subscription/${id}`);
  },
  last(id) {
    return api.get(`/api/v1/subscription/last?customer_id=${id}`);
  },
  subscribeAmountCollectedStatistics(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/report/subscription-collecting?${p}`);
  },
  installationAmountSummary(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/report/supervisor-installation?${p}`);
  },
  exportToExcel(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/subscription?${p}`, {
      responseType: "blob",
    });
  },
  checkFtthSubscriptionCustomerPrice(customer_id, account_type_id, period) {
    return api.get(
      `/api/v1/subscription/price?customer_id=${customer_id}&account_type_id=${account_type_id}&period=${period}`
    );
  },
  checkFtthSubscriptionCustomerPrice2(
    customer_id,
    account_type_id,
    period,
    is_check_price_ftth
  ) {
    return api.get(
      `/api/v1/subscription/price?customer_id=${customer_id}&account_type_id=${account_type_id}&period=${period}&is_check_price_ftth=${is_check_price_ftth}`
    );
  },
  checkRenew(id) {
    return api.get(`/api/v1/customer/renew/${id}`);
  },
  renew(data) {
    return api.post(`/api/v1/customer/renew/${data.customer_id}`, data);
  },
};
